export default __webpack_public_path__ + "static/media/ico_12.ae31a226.png";